import { Box, Hidden } from '@mui/material'
import { makeStyles } from "@mui/styles";
import FAQAccordion from './FAQAccordion'
import { NormalText } from './StyledComponent';

const useStyles = makeStyles((theme) => ({
  footerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
  }
}))

export default function AuctionFooter() {
  const classes = useStyles()
  return (
    <Box className={classes.footerContainer}>
      <Hidden mdDown>
        <NormalText color={'#ECECEC'}>
          TATTERSALL MARCA COMERCIAL REGISTRADA. TODOS LOS DERECHOS
          RESERVADOS.
        </NormalText>
      </Hidden >
      <FAQAccordion>
        PREGUNTAS FRECUENTES
      </FAQAccordion>
    </Box >
  );
}
